import { render, staticRenderFns } from "./PrevMatch.vue?vue&type=template&id=5c0c1c32&scoped=true"
import script from "./PrevMatch.vue?vue&type=script&lang=js"
export * from "./PrevMatch.vue?vue&type=script&lang=js"
import style0 from "./PrevMatch.vue?vue&type=style&index=0&id=5c0c1c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0c1c32",
  null
  
)

export default component.exports